var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ClientBuyAndHoldIdeaService } from './com/unitedtraders/luna/mobilegateway/buyandhold/ClientBuyAndHoldIdeaService';
import { ConvertClientService } from './com/unitedtraders/luna/mobilegateway/convert/ConvertClientService';
import { DepositService } from './com/unitedtraders/luna/mobilegateway/deposit/DepositService';
import { InvoiceService } from './com/unitedtraders/luna/mobilegateway/invoice/InvoiceService';
import { ClientLimitedIdeaService } from './com/unitedtraders/luna/mobilegateway/limited/ClientLimitedIdeaService';
import { AccessRecoveryService } from './com/unitedtraders/luna/mobilegateway/recovery/AccessRecoveryService';
import { RegistrationService } from './com/unitedtraders/luna/mobilegateway/registration/RegistrationService';
import { ClientStocksService } from './com/unitedtraders/luna/mobilegateway/stocks/ClientStocksService';
import { ClientUnlimitedIdeaService } from './com/unitedtraders/luna/mobilegateway/unlimited/ClientUnlimitedIdeaService';
import { MobileApplicationVersionService } from './com/unitedtraders/luna/mobilegateway/version/MobileApplicationVersionService';
import { WithdrawService } from './com/unitedtraders/luna/mobilegateway/withdraw/WithdrawService';
import { schema } from './schema';
import { BaseApiClient } from '@utex/base-api-sdk';
var ApiClient = (function (_super) {
    __extends(ApiClient, _super);
    function ApiClient(config, logger, getTokens, getTraceId) {
        var _this = _super.call(this, config, logger, schema, getTokens, getTraceId) || this;
        _this.accessRecoveryService = new AccessRecoveryService(_this.clients, _this.logger, _this.schema, config);
        _this.convertClientService = new ConvertClientService(_this.clients, _this.logger, _this.schema, config);
        _this.invoiceService = new InvoiceService(_this.clients, _this.logger, _this.schema, config);
        _this.clientLimitedIdeaService = new ClientLimitedIdeaService(_this.clients, _this.logger, _this.schema, config);
        _this.clientUnlimitedIdeaService = new ClientUnlimitedIdeaService(_this.clients, _this.logger, _this.schema, config);
        _this.withdrawService = new WithdrawService(_this.clients, _this.logger, _this.schema, config);
        _this.depositService = new DepositService(_this.clients, _this.logger, _this.schema, config);
        _this.clientBuyAndHoldIdeaService = new ClientBuyAndHoldIdeaService(_this.clients, _this.logger, _this.schema, config);
        _this.registrationService = new RegistrationService(_this.clients, _this.logger, _this.schema, config);
        _this.clientStocksService = new ClientStocksService(_this.clients, _this.logger, _this.schema, config);
        _this.mobileApplicationVersionService = new MobileApplicationVersionService(_this.clients, _this.logger, _this.schema, config);
        return _this;
    }
    return ApiClient;
}(BaseApiClient));
export { ApiClient };
//# sourceMappingURL=ApiClient.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/utcom-api-sdk/es/ApiClient.js
// module id = 1468
// module chunks = 118